module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/icon8.c5044cb6.png";